import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ConfigContext } from '../../../context';
import DOMPurify from 'dompurify';

/**
 * Tyre link from sessionStorage
 * To test this run:
 * sessionStorage.tyreData = '{"tsViewNavItem":"#filterLicense","tsViews":"visible","width":205,"height":50,"rim":17,"id":"T430528","productName":"Nokian Hakka Black 2","productInfo":"205/50R17 93W XL"}'
 * @return {JSX}
 */
const Tyre = () => {
  const { t } = useTranslation('dealers');
  const { config } = useContext(ConfigContext);

  // Return null if no tyreData in sessionStorage
  if (typeof sessionStorage.tyreData === 'undefined') {
    return null;
  }

  let tyreData = false;

  // Try catch for JSON.parse
  try {
    tyreData = JSON.parse(sessionStorage.tyreData);
  } catch (e) {
    console.warn(e.message);
  }


  // Return null if no tyreData or product info
  if (tyreData === false
    || config.disableChosenTyre
    || typeof tyreData.productInfo === 'undefined'
    || typeof tyreData.productName === 'undefined') {
    return null;
  }

  const tyre = tyreData.productName + ' ' + tyreData.productInfo;

  return (
    <div className="chosen-tyre">
      <h4>{t('Your chosen tyre')}</h4>
      <p>
        <span dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(tyre)}} />
        <a href={window.ntTyreHref}>{t('Change')}</a>
      </p>
    </div>
  )
}

export default Tyre;
